import { jsx as _jsx } from "react/jsx-runtime";
import { CloudUpload } from "@air/next-icons";
import { MONTH_DAY_YEAR_FORMAT, parseAirDateToISO } from "@air/utilities";
import { format } from "__barrel_optimize__?names=format!=!date-fns";
import capitalize from "lodash/capitalize";
import { memo } from "react";
import { useSelector } from "react-redux";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailValue } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue";
import { SOURCE_MAP } from "~/constants/sourceMap";
import { centralizedClipCreatedDateSelector, centralizedClipOwnerSelector, centralizedClipSourceSelector } from "~/store/centralizedClip/selectors";
export const InfoPanelUploadedBy = /*#__PURE__*/ memo(()=>{
    const owner = useSelector(centralizedClipOwnerSelector);
    const source = useSelector(centralizedClipSourceSelector);
    const uploadedAt = useSelector(centralizedClipCreatedDateSelector);
    var _SOURCE_MAP_source;
    return /*#__PURE__*/ _jsx(InfoPanelDetailsSection, {
        Icon: CloudUpload,
        title: "Uploaded",
        children: /*#__PURE__*/ _jsx(InfoPanelDetailValue, {
            value: format(parseAirDateToISO(uploadedAt), MONTH_DAY_YEAR_FORMAT),
            additionalInfo: "Uploaded via ".concat((_SOURCE_MAP_source = SOURCE_MAP === null || SOURCE_MAP === void 0 ? void 0 : SOURCE_MAP[source]) !== null && _SOURCE_MAP_source !== void 0 ? _SOURCE_MAP_source : capitalize(source), " by ").concat(owner.ownerName)
        })
    });
});
InfoPanelUploadedBy.displayName = "InfoPanelUploadedBy";
